import { render, staticRenderFns } from "./supplierBottom.vue?vue&type=template&id=5e3e42d4"
import script from "./supplierBottom.vue?vue&type=script&lang=js"
export * from "./supplierBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports